import React, { useState } from 'react'
import { Button, Space } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import CreatePatternDropdown from './create-pattern-dropdown/CreatePatternDropdown'
import { useDispatch, useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import { isExcelAssignment, isMba, isTextAssignment } from '../../../../utils/assignment.helper'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import EditFileGradingButton from './edit-file-grading-modal/EditFileGradingButton'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import userSelectors from '../../../../store/selectors/user.selectors'

const FileDrawerFooter = () => {
    const drawer = useSelector(state => state.assignment.drawer)
    const language = useSelector(assignmentSelectors.language)
    const type = useSelector(assignmentSelectors.type)
    const isFileInGroupX = useSelector(submissionSelectors.isOpenedSubmissionInGroupX)
    const isFileInGroupY = useSelector(submissionSelectors.isOpenedSubmissionInGroupY)
    const isShopUser = useSelector(userSelectors.isShopUser)

    const dispatch = useDispatch()

    const { token } = useParams()

    const [isWaitingForDownloadFile, setIsWaitingForDownloadFile] = useState(false)

    const handleGetXMLClick = () => dispatch(actions.getFileXML(token, drawer?.file?.id))

    const handleDownloadFileClick = async () => {
        setIsWaitingForDownloadFile(true)
        await dispatch(actions.downloadFile(token, drawer?.file?.id, drawer?.file?.name))
        setIsWaitingForDownloadFile(false)
    }

    return isExcelAssignment(language) ? (
        <Space>
            <Button onClick={handleDownloadFileClick} loading={isWaitingForDownloadFile}>
                <DownloadOutlined /> Download File
            </Button>
        </Space>
    ) : (
        <Space>
            {isFileInGroupX && isMba(type) && <EditFileGradingButton />}
            {!isShopUser && <CreatePatternDropdown />}
            {!isFileInGroupY && !isMba(type) && !isTextAssignment(language) && (
                <Button onClick={handleGetXMLClick}>Get XML</Button>
            )}
        </Space>
    )
}

export default FileDrawerFooter
